import {IState, IStateParamsService} from 'angular-ui-router';
import {PageNameConstants} from '../core/service/PageNameConstants';
import SchadenfallModelManager from '../core/service/SchadenfallModelManager';
import {RouterHelper} from '../dvbModules/router/route-helper-provider';
import TSBeitrag from '../models/TSBeitrag';
import TSEigenleistung from '../models/TSEigenleistung';
import TSEigenleistungDaten from '../models/TSEigenleistungDaten';
import TSFremdkosten from '../models/TSFremdkosten';
import TSFremdkostenDaten from '../models/TSFremdkostenDaten';
import TSSchaden from '../models/TSSchaden';
import TSSchadenDaten from '../models/TSSchadenDaten';
import TSSchadenfall from '../models/TSSchadenfall';
import TSSchadenObjektDaten from '../models/TSSchadenObjektDaten';
import TSVorleistung from '../models/TSVorleistung';
import TSVorleistungDaten from '../models/TSVorleistungDaten';
import DVBernUtil from '../utils/DVBernUtil';
import ILogService = angular.ILogService;
import IPromise = angular.IPromise;
import IQService = angular.IQService;

gesuchRun.$inject = ['RouterHelper', 'PAGE_NAMES'];

/* @ngInject */
export function gesuchRun(routerHelper: RouterHelper, pageNames: PageNameConstants) {
    if (pageNames === undefined) {
        console.error('Page Names must be injected');
    }
    routerHelper.configureStates(getStates(pageNames));
}

function getStates(pageNames: PageNameConstants): IState[] {
    return [
        new SerfBemerkungState(pageNames.BEMERKUNG),
        new SerfGesuchErstellenState(pageNames.GESUCHERSTELLEN),
        new SerfAbschlussState(pageNames.ABSCHLUSS),
        new SerfSchadenmeldungState(pageNames.SCHADENMELDUNG),
        new SerfSchadenState(pageNames.SCHADEN), //it is used only for showing legacy cases with more than one schaden
        new SerfAufwaendeState(pageNames.AUFWAENDE),
        new SerfSchaetzungState(pageNames.SCHAETZUNG),
        new SerfEigenleistungenState(pageNames.EIGENLEISTUNGEN),
        new SerfVorleistungState(pageNames.VORLEISTUNG),
        new SerfFremdkostenState(pageNames.FREMDKOSTEN),
        new SerfEntschaedigungState(pageNames.ENTSCHAEDIGUNG),
        new SerfBeitragState(pageNames.BEITRAG),
        new SerfBankkontoState(pageNames.BANKKONTO),
    ];
}

//STATES
export class SerfBemerkungState implements IState {
    name = 'bemerkung';
    template = '<dv-bemerkung-view schadenfall="$resolve.schadenfall"></dv-bemerkung-view>';
    url = '/bemerkung/:schadenfallId';
    resolve = {
        schadenfall: getSchadenfall,
    };

    constructor(statename: string) {
        this.name = statename;
    }
}

export class SerfGesuchErstellenState implements IState {
    name = 'gesucherstellen';
    template = '<dv-gesuch-erstellen-view schadenfall="$resolve.schadenfall"></dv-gesuch-erstellen-view>';
    url = '/gesucherstellen/:createNew/:schadenfallId';
    resolve = {
        schadenfall: getOrCreateSchadenfall,
    };

    constructor(statename: string) {
        this.name = statename;
    }
}

export class SerfSchadenmeldungState implements IState {
    name = 'schadenmeldung';
    template = '<dv-schadenfall-view schadenfall="$resolve.schadenfall"></dv-schadenfall-view>';
    url = '/schadenmeldung/:schadenfallId';
    resolve = {
        schadenfall: getSchadenfall,
    };

    constructor(statename: string) {
        this.name = statename;
    }
}

export class SerfAbschlussState implements IState {
    name = 'abschluss';
    template = '<dv-abschluss-view title-text="$resolve.titleText" message-text="$resolve.messageText" '
        + 'button-text="$resolve.buttonText" state-to-go-to="$resolve.stateToGoTo"></dv-abschluss-view>';
    url = '/abschluss';
    resolve = {
        titleText: getTitleText,
        messageText: getMsgText,
        buttonText: getButtonText,
        stateToGoTo: getStateToGo,

    };
    params = {titleText: null, messageText: null, buttonText: null, stateToGoTo: null};

    constructor(statename: string) {
        this.name = statename;
    }
}

export class SerfAufwaendeState implements IState {
    name = 'aufwaende';
    template = '<dv-aufwaende-view schadenfall="$resolve.schadenfall" schaetzung="false"></dv-aufwaende-view>';
    url = '/aufwaende/:schadenfallId';
    resolve = {
        schadenfall: getSchadenfall,
    };

    constructor(statename: string) {
        this.name = statename;
    }
}

export class SerfSchaetzungState implements IState {
    name = 'schaetzung';
    template = '<dv-aufwaende-view schadenfall="$resolve.schadenfall" schaetzung="true"></dv-aufwaende-view>';
    url = '/schaetzung/:schadenfallId';
    resolve = {
        schadenfall: getSchadenfall,
    };

    constructor(statename: string) {
        this.name = statename;
    }
}

export class SerfEigenleistungenState implements IState {
    name = 'eigenleistungen';
    template = '<dv-eigenleistung-edit-view eigenleistung="$resolve.eigenleistung" '
        + 'schadenfall-id="$resolve.schadenfallId" schaetzung="$resolve.schaetzung"></dv-eigenleistung-edit-view>';
    resolve = {
        eigenleistung: getEigenleistung,
        schadenfallId: extractSchadenfallId,
        schaetzung: isSchaetzung,
    };
    url = '/aufwaende/schadenfallId/eigenleistungen/:eigenleistungId?schaetzung';
    params = {eigenleistung: null, schadenfallId: null, eigenleistungId: null, schaetzung: null};

    constructor(statename: string) {
        this.name = statename;
    }
}

export class SerfSchadenState implements IState {
    name = 'schaden';
    template = '<dv-schaden-edit-view schaden="$resolve.schaden" '
        + 'schadenfall-id="$resolve.schadenfallId" mehr-schaden-ansicht="true" readonly="false"></dv-schaden-edit-view>';
    url = '/schadenfall/:schadenfallId/schaden/:schadenId';
    resolve = {
        schaden: getSchaden,
        schadenfallId: extractSchadenfallId,
    };
    params = {schaden: null, schadenfallId: null, schadenId: null};

    constructor(statename: string) {
        this.name = statename;
    }
}

export class SerfVorleistungState implements IState {
    name = 'vorleistung';
    template = '<dv-vorleistung-edit-view vorleistung="$resolve.vorleistung" '
        + 'schadenfall-id="$resolve.schadenfallId" schaetzung="$resolve.schaetzung"></dv-vorleistung-edit-view>';
    url = '/aufwaende/:schadenfallId/vorleistungen/:vorleistungId?schaetzung';
    resolve = {
        vorleistung: getVorleistung,
        schadenfallId: extractSchadenfallId,
        schaetzung: isSchaetzung,
    };
    params = {vorleistung: null, schadenfallId: null, vorleistungId: null, schaetzung: null};

    constructor(statename: string) {
        this.name = statename;
    }
}

export class SerfFremdkostenState implements IState {
    name = 'fremdkosten';
    template = '<dv-fremdkosten-edit-view fremdkosten="$resolve.fremdkosten" '
        + 'schadenfall-id="$resolve.schadenfallId" schaetzung="$resolve.schaetzung"></dv-fremdkosten-edit-view>';
    url = '/aufwaende/:schadenfallId/fremdkosten/:fremdkostenId?schaetzung';
    resolve = {
        fremdkosten: getFremdkosten,
        schadenfallId: extractSchadenfallId,
        schaetzung: isSchaetzung,
    };
    params = {fremdkosten: null, schadenfallId: null, fremdkostenId: null, schaetzung: null};

    constructor(statename: string) {
        this.name = statename;
    }
}

export class SerfEntschaedigungState implements IState {
    name = 'entschaedigung';
    template = '<dv-entschaedigung-view schadenfall="$resolve.schadenfall"></dv-entschaedigung-view>';
    url = '/entschaedigung/:schadenfallId';
    resolve = {
        schadenfall: getSchadenfall,
    };

    constructor(statename: string) {
        this.name = statename;
    }
}

export class SerfBeitragState implements IState {
    name = 'beitrag';
    template = '<dv-beitrag-view beitrag="$resolve.beitrag" schadenfall="$resolve.schadenfall"></dv-beitrag-view>';
    url = '/entschaedigung/:schadenfallId/beitrag/:beitragId';
    resolve = {
        beitrag: getBeitrag,
        schadenfall: getSchadenfall,
    };
    params = {beitrag: null, schadenfall: null, beitragId: null};

    constructor(statename: string) {
        this.name = statename;
    }
}

export class SerfBankkontoState implements IState {
    name = 'bankkonto';
    template = '<dv-bankkonto-view schadenfall="$resolve.schadenfall"></dv-bankkonto-view>';
    url = '/bankkonto/:schadenfallId';
    resolve = {
        schadenfall: getSchadenfall,
    };

    constructor(statename: string) {
        this.name = statename;
    }
}

export class INewFallStateParams implements IStateParamsService {
    createNew: string;
    schadenfallId: string;
}

export class IAbschlussStateParams implements IStateParamsService {
    titleText: string;
    messageText: string;
    buttonText: string;
    stateToGoTo: string;
}

export class IFallStateParams implements IStateParamsService {
    schadenfallId: string;
}

export class IEigenleistungeStateParams implements IStateParamsService {
    schadenfallId: string;
    eigenleistungId: string;
    eigenleistung: TSEigenleistung;
    schaetzung: string;
}

export class ISchadenStateParams implements IStateParamsService {
    schadenfallId: string;
    schadenId: string;
    schaden: TSSchaden;
}

export class IFremdkostenStateParams implements IStateParamsService {
    schadenfallId: string;
    fremdkostenId: string;
    fremdkosten: TSFremdkosten;
    schaetzung: string;
}

export class IVorleistungStateParams implements IStateParamsService {
    schadenfallId: string;
    vorleistungId: string;
    vorleistung: TSVorleistung;
    schaetzung: string;
}

export class IBeitragStateParams implements IStateParamsService {
    schadenfallId: string;
    schadenfall: TSSchadenfall;
    beitrag: TSBeitrag;
    beitragId: string | undefined;
}

getTitleText.$inject = ['$stateParams'];

export function getTitleText($stateParams: IAbschlussStateParams) {
    if ($stateParams) {
        return $stateParams.titleText;
    }
    return undefined;
}

getMsgText.$inject = ['$stateParams'];

export function getMsgText($stateParams: IAbschlussStateParams) {
    if ($stateParams) {
        return $stateParams.messageText;
    }
    return undefined;
}

getButtonText.$inject = ['$stateParams'];

export function getButtonText($stateParams: IAbschlussStateParams) {
    if ($stateParams) {
        return $stateParams.buttonText;
    }
    return undefined;
}

isSchaetzung.$inject = ['$stateParams'];

export function isSchaetzung($stateParams: IEigenleistungeStateParams): boolean {
    if ($stateParams) {
        // === 'true' is necessary, because $stateParams.schaetzung is a string
        // and "false" would also evaluates as true
        return $stateParams.schaetzung === 'true';
    }
    return false;
}

getStateToGo.$inject = ['$stateParams'];

export function getStateToGo($stateParams: IAbschlussStateParams) {
    if ($stateParams) {
        return $stateParams.stateToGoTo;
    }
    return undefined;
}

// FIXME dieses $inject wird ignoriert, d.h, der Parameter der Funktion muss exact dem Namen des Services entsprechen
// (Grossbuchstaben am Anfang). Warum?
getOrCreateSchadenfall.$inject = ['$stateParams', '$q', 'SchadenfallModelManager'];

/* @ngInject */
export function getOrCreateSchadenfall($stateParams: INewFallStateParams, $q: IQService,
                                       schadenfallModelManager: SchadenfallModelManager,
): IPromise<TSSchadenfall> {
    if ($stateParams) {
        let schadenfallIdParam = $stateParams.schadenfallId;
        let createNewParam = $stateParams.createNew;
        if (createNewParam === 'false' && schadenfallIdParam) {
            return schadenfallModelManager.openSchadenfall(schadenfallIdParam);
        }
    }
    return schadenfallModelManager.initNewSchadenfall();
}

getSchadenfall.$inject = ['$stateParams', '$q', 'SchadenfallModelManager', '$log'];

/* @ngInject */
export function getSchadenfall($stateParams: IFallStateParams, $q: IQService,
                               schadenfallModelManager: SchadenfallModelManager,
                               log: ILogService,
): IPromise<TSSchadenfall> {
    if ($stateParams) {
        let schadenfallIdParam = $stateParams.schadenfallId;
        if (schadenfallIdParam) {
            if (schadenfallModelManager.isSchadenfall(schadenfallIdParam)) {
                return $q.when(schadenfallModelManager.getSchadenfall()!);     //we already checked for null, hence !
            } else {
                return schadenfallModelManager.openSchadenfall(schadenfallIdParam);
            }
        }
    }
    log.error('Can`t open schadenfall on view!!! createOrUpdate a new one...');
    return schadenfallModelManager.initNewSchadenfall();
}

getEigenleistung.$inject = ['$stateParams', '$q', 'SchadenfallModelManager', '$log'];

/* @ngInject */
export function getEigenleistung($stateParams: IEigenleistungeStateParams, $q: IQService,
                                 schadenfallModelManager: SchadenfallModelManager,
                                 log: ILogService,
): IPromise<TSEigenleistung> {
    if ($stateParams) {
        let schaetzung = $stateParams.schaetzung === 'true';
        let schadenfallIdParam = $stateParams.schadenfallId;
        let eigenleistungenIdParam = $stateParams.eigenleistungId;
        let passedEigenleistung = $stateParams.eigenleistung;
        if (passedEigenleistung) {
            return $q.when(passedEigenleistung);
        }
        if (schadenfallIdParam && eigenleistungenIdParam) {
            let schadenfallProm: IPromise<TSSchadenfall>;
            if (schadenfallModelManager.isSchadenfall(schadenfallIdParam)) {
                schadenfallProm = $q.when(schadenfallModelManager.getSchadenfall()!);
            } else {
                schadenfallProm = schadenfallModelManager.openSchadenfall(schadenfallIdParam);
            }
            return schadenfallProm.then((schadenfall) => {
                let eigenleistungen = schadenfall.eigenleistungen || [];
                let i = DVBernUtil.getIndexOfElementwithIDById(eigenleistungenIdParam, eigenleistungen);
                if (i >= 0) {
                    return $q.when(eigenleistungen[i]);
                } else {
                    log.error('Can`t open requested eigenleistungen on schadenfall. creating a new one...');
                    return $q.when(createNewEigenleistungObj(schaetzung));

                }
            })
        }
    }

    log.error('Can`t open requested schadenfall. creating a new eigenleistungo object');
    return $q.when(createNewEigenleistungObj(false));
}

getSchaden.$inject = ['$stateParams', '$q', 'SchadenfallModelManager', '$log'];

/* @ngInject */
export function getSchaden($stateParams: ISchadenStateParams, $q: IQService,
                           schadenfallModelManager: SchadenfallModelManager,
                           log: ILogService,
): IPromise<TSSchaden> {
    if ($stateParams) {
        let schadenfallIdParam = $stateParams.schadenfallId;
        let schaedenIdParam = $stateParams.schadenId;
        let passedSchaden = $stateParams.schaden;
        if (passedSchaden) {
            return $q.when(passedSchaden);
        }
        if (schadenfallIdParam && schaedenIdParam) {
            let schadenfallProm: IPromise<TSSchadenfall>;
            if (schadenfallModelManager.isSchadenfall(schadenfallIdParam)) {
                schadenfallProm = $q.when(schadenfallModelManager.getSchadenfall()!);
            } else {
                schadenfallProm = schadenfallModelManager.openSchadenfall(schadenfallIdParam);
            }
            return schadenfallProm.then((schadenfall) => {
                let schaeden = schadenfall.schaeden || [];
                let i = DVBernUtil.getIndexOfElementwithIDById(schaedenIdParam, schaeden);
                if (i >= 0) {
                    return $q.when(schaeden[i]);
                } else {
                    log.error('Can`t open requested schaeden on schadenfall. creating a new one...');
                    return $q.when(createNewSchadenObj());

                }
            })
        }
    }

    log.error('Can`t open requested schadenfall. creating a new schaden object');
    return $q.when(createNewSchadenObj());
}

getVorleistung.$inject = ['$stateParams', '$q', 'SchadenfallModelManager', '$log'];

/* @ngInject */
export function getVorleistung($stateParams: IVorleistungStateParams, $q: IQService,
                               schadenfallModelManager: SchadenfallModelManager,
                               log: ILogService,
): IPromise<TSVorleistung> {
    if ($stateParams) {
        let schadenfallIdParam = $stateParams.schadenfallId;
        let vorleistungIdParam = $stateParams.vorleistungId;
        let passedVorleistung = $stateParams.vorleistung;
        if (passedVorleistung) {
            return $q.when(passedVorleistung);
        }
        if (schadenfallIdParam && vorleistungIdParam) {
            let schadenfallProm: IPromise<TSSchadenfall>;
            if (schadenfallModelManager.isSchadenfall(schadenfallIdParam)) {
                schadenfallProm = $q.when(schadenfallModelManager.getSchadenfall()!);
            } else {
                schadenfallProm = schadenfallModelManager.openSchadenfall(schadenfallIdParam);
            }
            return schadenfallProm.then((schadenfall) => {
                let vorleistungen = schadenfall.vorleistungen || [];
                let i = DVBernUtil.getIndexOfElementwithIDById(vorleistungIdParam, vorleistungen);
                if (i >= 0) {
                    return $q.when(vorleistungen[i]);
                } else {
                    log.error('Can`t open requested vorleistungen on schadenfall. creating a new one...');
                    return $q.when(createNewVorleistungObj());

                }
            })
        }
    }

    log.error('Can`t open requested schadenfall. creating a new vorleistung object');
    return $q.when(createNewVorleistungObj());
}

getBeitrag.$inject = ['$stateParams', '$q', 'SchadenfallModelManager', '$log'];

/* @ngInject */
export function getBeitrag($stateParams: IBeitragStateParams, $q: IQService,
                           schadenfallModelManager: SchadenfallModelManager,
                           log: ILogService,
): IPromise<TSBeitrag> {

    if ($stateParams) {
        let schadenfallIdParam = $stateParams.schadenfallId;
        let beitragIdParam = $stateParams.beitragId;
        let passedBeitrag = $stateParams.beitrag;
        if (passedBeitrag) {
            return $q.when(passedBeitrag);
        }
        if (schadenfallIdParam && beitragIdParam) {
            let schadenfallProm: IPromise<TSSchadenfall>;
            if (schadenfallModelManager.isSchadenfall(schadenfallIdParam)) {
                schadenfallProm = $q.when(schadenfallModelManager.getSchadenfall()!);
            } else {
                schadenfallProm = schadenfallModelManager.openSchadenfall(schadenfallIdParam);
            }
            return schadenfallProm.then((schadenfall) => {
                let beitraege = schadenfall.beitraege || [];
                let i = DVBernUtil.getIndexOfElementwithIDById(beitragIdParam, beitraege);
                if (i >= 0) {
                    return $q.when(beitraege[i]);
                } else {
                    log.error('Can`t open requested beitrag on schadenfall. creating a new one...');
                    return $q.when(createNewBeitragObj());

                }
            })
        }
    }

    log.error('Can`t open requested schadenfall. creating a new beitrag object');
    return $q.when(createNewBeitragObj());
}

getFremdkosten.$inject = ['$stateParams', '$q', 'SchadenfallModelManager', '$log'];

/* @ngInject */
export function getFremdkosten($stateParams: IFremdkostenStateParams, $q: IQService,
                               schadenfallModelManager: SchadenfallModelManager,
                               log: ILogService,
): IPromise<TSFremdkosten> {
    if ($stateParams) {
        let schadenfallIdParam = $stateParams.schadenfallId;
        let fremdkostenIdParam = $stateParams.fremdkostenId;
        let passedFremdkosten = $stateParams.fremdkosten;
        let schaetzung = $stateParams.schaetzung === 'true';
        if (passedFremdkosten) {
            return $q.when(passedFremdkosten);
        }
        if (schadenfallIdParam && fremdkostenIdParam) {
            let schadenfallProm: IPromise<TSSchadenfall>;
            if (schadenfallModelManager.isSchadenfall(schadenfallIdParam)) {
                schadenfallProm = $q.when(schadenfallModelManager.getSchadenfall()!);
            } else {
                schadenfallProm = schadenfallModelManager.openSchadenfall(schadenfallIdParam);
            }
            return schadenfallProm.then((schadenfall) => {
                let fremdkosten = schadenfall.fremdkosten || [];
                let i = DVBernUtil.getIndexOfElementwithIDById(fremdkostenIdParam, fremdkosten);
                if (i >= 0) {
                    return $q.when(fremdkosten[i]);
                } else {
                    log.error('Can`t open requested fremdkosten on schadenfall. creating a new one...');
                    return $q.when(createNewFremdkostenObj(schaetzung));

                }
            })
        }
    }

    log.error('Can`t open requested schadenfall. creating a new fremdkosten object');
    return $q.when(createNewFremdkostenObj(false));
}

extractSchadenfallId.$inject = ['$stateParams', '$q', '$log'];

export function extractSchadenfallId($stateParams: any, $q: IQService, log: ILogService): IPromise<string> {
    return $q.when($stateParams.schadenfallId);
}

function createNewEigenleistungObj(schaetzung: boolean): TSEigenleistung {
    let eigenleistungen = new TSEigenleistung();
    eigenleistungen.schaetzung = schaetzung;
    eigenleistungen.eigenleistungDatenFS = new TSEigenleistungDaten();
    return eigenleistungen;
}

function createNewSchadenObj(): TSSchaden {
    let schaden = new TSSchaden();
    schaden.schadenDatenFS = new TSSchadenDaten();
    schaden.schadenDatenFS.schadenObjektDaten = new TSSchadenObjektDaten();
    return schaden;
}

function createNewVorleistungObj(): TSVorleistung {
    let vorleistung = new TSVorleistung();
    vorleistung.vorleistungDatenFS = new TSVorleistungDaten();
    return vorleistung;
}

function createNewBeitragObj(): TSBeitrag {
    let beitrag = new TSBeitrag();
    return beitrag;
}

function createNewFremdkostenObj(schaetzung: boolean): TSFremdkosten {
    let fremdkosten = new TSFremdkosten();
    fremdkosten.schaetzung = schaetzung;
    fremdkosten.fremdkostenDatenFS = new TSFremdkostenDaten();
    return fremdkosten;
}





// WEBPACK FOOTER //
// ./src/app/gesuch/gesuch.route.ts